
import { Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { GoodType } from '../../models/entities/good-type.model';
import { IncomingEntity } from '../../models/entities/incoming-entity.model';

export default class ViewData extends Vue {
    @Prop() filterRoute!: GoodType;
    @Prop() currentData!: unknown | IncomingEntity;

    leftCol = 4;
    rightCol = 12 - this.leftCol;
}
